import { useEffect } from 'react';
import { applyFontToCSSVariables } from '../config/fonts';

/**
 * FontProvider component that applies the font configuration to CSS variables
 * This ensures the font from fonts.js is applied to the entire application
 */
const FontProvider = ({ children }) => {
  useEffect(() => {
    // Apply font configuration when component mounts
    applyFontToCSSVariables();
  }, []);

  return children;
};

export default FontProvider;
